import DateTime from "date-and-time"


export const getStartAndLastDay = (date) => {
  let startDay = DateTime.format(new Date(date.getFullYear(), date.getMonth(), 1), "YYYY-MM-DD")
  let lastDay = DateTime.format(new Date(date.getFullYear(), date.getMonth() + 1, 0), "YYYY-MM-DD")

  return { startDay, lastDay }
}